import { render, staticRenderFns } from "./dataConfirmationRegistration.vue?vue&type=template&id=6b84457a&scoped=true&"
import script from "./dataConfirmationRegistration.vue?vue&type=script&lang=js&"
export * from "./dataConfirmationRegistration.vue?vue&type=script&lang=js&"
import style0 from "./dataConfirmationRegistration.vue?vue&type=style&index=0&id=6b84457a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84457a",
  null
  
)

export default component.exports